import { jsx as _jsx } from "react/jsx-runtime";
import { responsiveFontSizes, ScopedCssBaseline, ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import clone from 'lodash/clone';
import { useContext } from 'react';
import InvertableThemeContext from './InvertableThemeContext';
const InvertableThemeProvider = (props) => {
    var _a;
    const contextInvertableTheme = useContext(InvertableThemeContext);
    const { children, dark, scoped = false, invert = false, noResponsiveFonts } = props;
    const { options = clone(contextInvertableTheme.options) } = props;
    options.palette = (_a = options.palette) !== null && _a !== void 0 ? _a : {};
    if (invert) {
        options.palette.mode = options.palette.mode === 'dark' ? 'light' : 'dark';
    }
    if (dark !== undefined) {
        options.palette.mode = dark ? 'dark' : 'light';
    }
    let theme = createTheme(options);
    if (!noResponsiveFonts) {
        theme = responsiveFontSizes(theme);
    }
    return scoped ? (_jsx(ScopedCssBaseline, { children: _jsx(InvertableThemeContext.Provider, Object.assign({ value: { options } }, { children: _jsx(ThemeProvider, Object.assign({ theme: theme }, { children: children }), void 0) }), void 0) }, void 0)) : (_jsx(InvertableThemeContext.Provider, Object.assign({ value: { options } }, { children: _jsx(ThemeProvider, Object.assign({ theme: theme }, { children: children }), void 0) }), void 0));
};
export default InvertableThemeProvider;
//# sourceMappingURL=InvertableThemeProvider.js.map